import React from 'react'
import Image from '../../../images/sellerpolicies/6.png'

const Discount_policy = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Discount Policy</h2>
            <p>Seller is required to give discounts on occasions like Eid, Independence, New year, 11-11, Defense Day, and other public occasions. KAAY will also contribute to discounts in order to increase discount percentages.</p>
        </div>
      </div>
    </div>
  )
}

export default Discount_policy
